import angular from 'angular';
import _ from 'lodash';

import editInfoTpl from './edit.info.html';
import chooseCompanyTpl from './choose.company.modal.html';

import BlndTable from 'app/common/table';


export class ListCtrl {
    constructor ($stateParams, $state, NgTableParams, CustomerStore, UserService) {
        "ngInject";
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.$user = UserService.$user;
        this.defaultParams = {
            is_active: 'True',
            ordering: ['title'],
            page_size: 20,
        };
        this.showOnlyHidden = false

        this.resetParams();
        this.applyQSParams();
        this.table = new BlndTable(
            NgTableParams, CustomerStore,
            {
                defaultParams: this.defaultParams,
                params: this.params,
                onChange: (params) => this.onChange(params)
            }
        );
    }

    applyQSParams () {
        let params = {};
        for (let k of Object.keys(this.$stateParams)) {
            let v = this.$stateParams[k];
            if (!_.isUndefined(v)) {
                params[k] = v;
            }
        }

        params.companies = _.parseInt(params.companies) || undefined;
        params.sales = parseInt(params.sales) || undefined;
        params.page = parseInt(params.page) || undefined;

        _.extend(this.params, params);
    }

    onChange (params_) {
        // clear current params:
        let params = {};
        for (let [k, v] of Object.entries(this.$state.$current.params)) {
            if (v.location === 'search') {
                params[k] = undefined;
            }
        }
        params = _.extend(params, params_);
        this.$state.go('.', params, {notify: false});
    }

    resetParams () {
        this.params = _.clone(this.defaultParams);
        this.showOnlyHidden = false
    }

    showHidden() {
        this.showOnlyHidden = !this.showOnlyHidden
        this.params = _.extend(this.params, {'hidden': this.showOnlyHidden});
    }

    refresh () {
        return this.table.refresh(this.params);
    }
}

export class DetailCtrl {
    constructor($customer) {
        "ngInject";
        this.customer = $customer;
    }
}

export class EditInfoCtrl {
    constructor (R, $uibModalInstance, customer, CustomerStore) {
        "ngInject";
        this.R = R;
        this.customer = customer;
        this.CustomerStore = CustomerStore;
        this.data = this.R.copy(customer);
        this.$modal = $uibModalInstance;
        this.loading = false;
    }

    close () {
        this.$modal.dismiss();
    }

    submit () {
        let self = this;
        // Remove from request readonly fields
        let readOnlyFields = [
            'first_name', 'last_name', 'name', 'address',
            'price_level', 'freight_zone', 'companies'
        ];
        // avoid glitch before send
        let data = this.R.copy(this.data);

        _.each(readOnlyFields, (field) => {
            delete data[field];
        });

        // `data.put()` no longer exists: `CustomerStore.get()` now returns a
        // plain object from the shared REST resource store rather than a
        // "live" Restangular element. Use `CustomerStore.update(id, data)`.
        this.CustomerStore.update(this.customer.id, data).then(
            function(data){
                angular.extend(self.customer, data);
                self.$modal.close();
            },
            function(resp) {
                self.errors = resp.data;
            },
        ).finally(() => self.loading = false);
    }
}

export class InfoCtrl {
    constructor($growl, Modal, $customer) {
        "ngInject";
        this.$growl = $growl;
        this.Modal = Modal;
        this.customer = $customer;
    }

    openEdit () {
        let self = this;
        let $modal = this.Modal.open({
            template: editInfoTpl,
            controller: EditInfoCtrl,
            size: 'lg',
            resolve: {
                customer: () => this.customer,
            },
        });
        $modal.result.then(function(){
            self.$growl.updated();
        });
    }
}


class ChooseCompanyModalCtrl {

    constructor ($uibModalInstance, customer) {
        "ngInject";
        this.data = {};
        this.customer = customer;
        this.$modal = $uibModalInstance;
        this.data.company = _.first(this.customer.companies);
    }

    get title () {
        return `Select company`;
    }

    close () {
        this.$modal.dismiss();
    }

    submit () {
        this.$modal.close(this.data.company);
    }

}


class CreateOrderOrTicket {

    constructor ($q, $customer, $growl, Modal, store) {
        this.customer = $customer;
        this.$growl = $growl;
        this.Modal = Modal;
        this.store = store;

        this.defered = $q.defer();
    }

    redirectTo (data) {
        throw 'Not implemented';
    }

    create () {
        let self = this;
        let company = _.first(self.customer.companies);

        if (self.customer.companies.length > 1) {
            let $modal = this.Modal.open({
                template: chooseCompanyTpl,
                controller: ChooseCompanyModalCtrl,
                size: 'small',
                resolve: {
                    customer: () => self.customer,
                },
            });

            $modal.result.then(function(data){
                self.defered.resolve(data);
            });
        } else {
            self.defered.resolve(company);
        }

        self.defered.promise.then(function (company) {
            self.store.create({
                customer: self.customer,
                company: company,
            }).then((data) => {
                self.$growl.added();
                self.redirectTo(data);
            });
        });
    }
}

export class TicketListCtrl extends CreateOrderOrTicket {

    constructor ($q, $customer, $growl, $state, Modal, TicketStore) {
        "ngInject";
        super($q, $customer, $growl, Modal, TicketStore);
        this.$state = $state;

    }

    redirectTo (data) {
        this.$state.go(
            'r.in.top.tickets.detail',
            {ticketId: data.id},
            {absolute: true}
        );
    }
}


export class OrderListCtrl extends CreateOrderOrTicket {
    constructor ($q, $customer, $growl, $state, Modal, OrderStore) {
        "ngInject";
        super($q, $customer, $growl, Modal, OrderStore);
        this.$state = $state;
    }

    redirectTo (data) {
        this.$state.go(
            'r.in.top.orders.detail',
            {orderId: data.id},
            {absolute: true}
        );
    }
}

export class FilesCtrl {
    constructor ($customer) {
        "ngInject";
        this.customer = $customer;
    }
}

export class LogCtrl {
    constructor () {}
}

export class CustomerNotificationsCtrl {
    constructor ($customer, $growl) {
        "ngInject";
        this.$growl = $growl
        this.customer = $customer;
        let customerNotifications = this.customer.notifications_settings
        this.notifications = {
            ticket_was_mixed_email_customer: customerNotifications? customerNotifications.ticket_was_mixed_email_customer : false,
            ticket_was_mixed_sms_customer: customerNotifications? customerNotifications.ticket_was_mixed_sms_customer : false,
            ticket_was_mixed_email_sales_person: customerNotifications? customerNotifications.ticket_was_mixed_email_sales_person : false,
            ticket_was_mixed_sms_sales_person: customerNotifications? customerNotifications.ticket_was_mixed_sms_sales_person : false,
            ticket_start_delivery_email_customer: customerNotifications? customerNotifications.ticket_start_delivery_email_customer : false,
            ticket_start_delivery_sms_customer: customerNotifications? customerNotifications.ticket_start_delivery_sms_customer : false,
            ticket_start_delivery_email_sales_person: customerNotifications? customerNotifications.ticket_start_delivery_email_sales_person : false,
            ticket_start_delivery_sms_sales_person: customerNotifications? customerNotifications.ticket_start_delivery_sms_sales_person : false,
            ticket_finish_delivery_email_customer: customerNotifications? customerNotifications.ticket_finish_delivery_email_customer : false,
            ticket_finish_delivery_sms_customer: customerNotifications? customerNotifications.ticket_finish_delivery_sms_customer : false,
            ticket_finish_delivery_email_sales_person: customerNotifications? customerNotifications.ticket_finish_delivery_email_sales_person : false,
            ticket_finish_delivery_sms_sales_person: customerNotifications? customerNotifications.ticket_finish_delivery_sms_sales_person : false,
            ticket_start_application_email_customer: customerNotifications? customerNotifications.ticket_start_application_email_customer : false,
            ticket_start_application_sms_customer: customerNotifications? customerNotifications.ticket_start_application_sms_customer : false,
            ticket_start_application_email_sales_person: customerNotifications? customerNotifications.ticket_start_application_email_sales_person : false,
            ticket_start_application_sms_sales_person: customerNotifications? customerNotifications.ticket_start_application_sms_sales_person : false,
            ticket_stop_application_email_customer: customerNotifications? customerNotifications.ticket_stop_application_email_customer : false,
            ticket_stop_application_sms_customer: customerNotifications? customerNotifications.ticket_stop_application_sms_customer : false,
            ticket_stop_application_email_sales_person: customerNotifications? customerNotifications.ticket_stop_application_email_sales_person : false,
            ticket_stop_application_sms_sales_person: customerNotifications? customerNotifications.ticket_stop_application_sms_sales_person : false,
            ticket_ready_to_bill_email_customer: customerNotifications? customerNotifications.ticket_ready_to_bill_email_customer : false,
            ticket_ready_to_bill_email_sales_person: customerNotifications? customerNotifications.ticket_ready_to_bill_email_sales_person : false,
            ticket_ready_to_bill_sms_customer: customerNotifications? customerNotifications.ticket_ready_to_bill_sms_customer : false,
            ticket_ready_to_bill_sms_sales_person: customerNotifications? customerNotifications.ticket_ready_to_bill_sms_sales_person : false,
        };
    }

    submitChange() {
        let self = this;
        this.customer.post('notifications', self.notifications).then(
            () => {
                self.$growl.success('Notifications settings updated!');
                self.errors = {}
                self.customer.notifications_settings = self.notifications
            },
            (response) => {
                self.$growl.error('Something went wrong', response.data);
            }
        )
    }
}



// WEBPACK FOOTER //
// ./src/app/customers/ctrls.js